<template>
  <div class="container">
    <div class="common-header-wrap">
      <mt-header :title="$t('menu.viewed_list')" class="common-header">
        <mt-button slot="left" icon="back" @click="$router.go(-1)"></mt-button>
        <mt-button slot="right" @click="clearallBrowse()">{{ $t('viewed.clear') }}</mt-button>
      </mt-header>
    </div>
    <div v-infinite-scroll="loadMore" infinite-scroll-disabled="loading" infinite-scroll-distance="10">
      <div class="ui-product-body"
           v-for='(item, index) in storebrowse_list'
           v-bind:key='index'
      >
        <div class="list-wrapper" v-if="storebrowse_list && storebrowse_list.length">
          <div class="list" @click="goStore(item.store_id)">
            <div class="ui-image-wrapper">
              <img class="product-img" v-lazy="item.store_avatar">
            </div>

            <div class="flex-right">
              <div class="product-header">
                <h3 class="title clear-bottom" style="-webkit-box-orient:vertical">{{ item.store_name }}</h3>
              </div>
            </div>
          </div>
          <!-- <mt-cell-swipe class="browse-list" v-for="(item, index) in storebrowse_list" v-bind:key="item.store_id">
            <div class="info">
              <img class="image" :src="item.store_avatar" />
              <div class="title" @click="goStore(item.store_id)">{{ item.store_name }}</div>
            </div>
        </mt-cell-swipe> -->
        </div>
      </div>
    </div>
    <empty-record v-if="storebrowse_list && !storebrowse_list.length"></empty-record>
  </div>
</template>

<script>
import { getBrowseList, clearallBrowse } from '../../../api/memberBrowse'
import { Toast, MessageBox, Indicator } from 'mint-ui'
import EmptyRecord from '../../../components/EmptyRecord'
export default {
  components: {
    EmptyRecord
  },
  data () {
    return {
      params: { 'page': 0, 'per_page': 10 },
      loading: false, // 是否加载更多
      isMore: true, // 是否有更多
      storebrowse_list: false
    }
  },
  created () {

  },
  methods: {
    // 清空我的足迹
    clearallBrowse () {
      clearallBrowse(this.params).then(res => {
        this.storebrowse_list = false
      }).catch(function (error) {
        Toast(error.message)
      })
    },
    goBack () {
      this.$router.go(-1)
    },
	goStore (store_id) {
      this.$router.push({ 'name': 'HomeStoredetail', 'query': { 'id': store_id } })
    },
    loadMore () {
      this.loading = true
      this.params.page = ++this.params.page
      if (this.isMore) {
        this.loading = false
        this.getBrowseList(true)
      }
    },
    getBrowseList () {
      Indicator.open()
      getBrowseList(this.params).then(res => {
        Indicator.close()
        if (res) {
          this.storebrowse_list = res.result.storebrowse_list
          if (res.result.hasmore) {
            this.isMore = true
          } else {
            this.isMore = false
          }
        }
      })
    }
  }
}
</script>

<style scoped lang="scss">
.container {
  height: 100%;
  display: flex;
  position: relative;
  flex-direction: column;
  justify-content: flex-start;
  align-items: stretch;

}
.header {
  border-bottom: 1px solid #e8eaed;
}
.ui-product-body {
  .list-wrapper {
    margin-bottom: 0.5rem;
  }
  .list {
    display: flex;
    width: auto;
    align-items: center;
    justify-content: space-between;
    padding: 0.5rem;
    position: relative;
    background: #fff;
    box-shadow: 0 0.1rem 0.2rem 0 rgba(200, 200, 200, 0.4);
    div.ui-image-wrapper {
      // width: 3rem;
      // height: 3rem;
      position: relative;
      border: 1px solid #e1e1e1;
      display: flex;
      justify-content: center;
      align-content: center;
      align-items: center;
      flex-basis: 3rem;
      flex-shrink: 0;
      height: 109px;
      width: 113px;
      border-radius: 20px;

      background-position: center center !important;
      background-size: 5rem 5rem;
      background-repeat: no-repeat;
      -webkit-background-size: cover;
      -moz-background-size: cover;
      -o-background-size: cover;
      background-size: cover;

      img.product-img {
        // width: 3rem;
        // height: 3rem;
        height: 109px;
        width: 113px;
        border-radius: 20px;
        flex-basis: 3rem;
        flex-shrink: 0;
        // border-radius:.3rem;
      }
    }
    .flex-right {
      // padding-top:.5rem;
      padding-left: 0.7rem;
      width: 100%;
      position: relative;
      .title {
        color: #333333;
        font-size: 0.8rem;
        line-height: 1rem;
        // font-weight: bolder;
        font-weight: bold;
        letter-spacing: 1px;
        display: -moz-box;
        display: -webkit-box;

        -webkit-line-clamp: 2;
        -moz-line-clamp: 2;

        -moz-box-orient: vertical;
        -webkit-box-orient: vertical;
        box-orient: vertical;

        overflow: hidden;
        margin-bottom: 0.4rem;
        &.clear-bottom {
          margin-bottom: 0;
        }
      }
    }
  }
}

</style>
